
import { NewsArticle } from "../types";
import { toast } from "@/components/ui/use-toast";

interface UseArticleManagementProps {
  articles: NewsArticle[];
  setArticles: React.Dispatch<React.SetStateAction<NewsArticle[]>>;
}

export const useArticleManagement = ({ articles, setArticles }: UseArticleManagementProps) => {
  // Delete article
  const handleDeleteArticle = (id: number) => {
    setArticles(articles.filter(article => article.id !== id));
    
    toast({
      title: "Επιτυχία",
      description: "Το άρθρο διαγράφηκε επιτυχώς"
    });
  };

  // Toggle publication status
  const handleTogglePublic = (id: number) => {
    setArticles(articles.map(article => 
      article.id === id 
        ? { ...article, isPublic: !article.isPublic } 
        : article
    ));
    
    const article = articles.find(a => a.id === id);
    const newStatus = article ? !article.isPublic : false;
    
    toast({
      title: "Επιτυχία",
      description: `Το άρθρο είναι τώρα ${newStatus ? 'δημόσιο' : 'ιδιωτικό'}`
    });
  };

  return { handleDeleteArticle, handleTogglePublic };
};
